var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 59,
    viewBox: "0 0 87 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2059_1470)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0082 33.9305C50.5424 33.1707 49.5537 32.9339 48.7965 33.3997C48.0393 33.8655 47.8025 34.8595 48.2682 35.6193L51.9736 41.6665C52.4394 42.4237 53.4307 42.6631 54.1879 42.1947C54.9425 41.7289 55.1793 40.735 54.7162 39.9778L51.0082 33.9305Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.462 5.40527C48.3853 5.40527 54.8098 11.848 54.8098 19.7947C54.8098 27.7414 48.3853 34.1842 40.462 34.1842C32.5361 34.1842 26.1116 27.7414 26.1116 19.7947C26.1116 11.848 32.5361 5.40527 40.462 5.40527Z",
    fill: "#80DEEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2059_1470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 21,
    height: 35
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.44458 1.64258H20.0538V35.6152H0.44458V1.64258Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2059_1470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.520081 23.3918L7.13194 22.4889L7.2022 24.2635C7.23602 25.1638 7.39475 27.1283 8.03746 27.8413C8.53706 28.3956 9.2136 28.5465 9.93437 28.5465C10.5146 28.5465 11.0871 28.4424 11.5841 28.1275C11.9692 27.8829 12.232 27.5785 12.3803 27.1466C12.6717 26.3061 12.6926 24.8906 12.6926 24.0059V2.20312H19.7754V23.7873C19.7754 25.8455 19.5933 28.2342 18.7554 30.1363C18.0216 31.8017 16.8403 33.1001 15.2478 33.977C13.6163 34.8747 11.8053 35.2338 9.95519 35.2338C7.28286 35.2338 4.73543 34.5104 2.88016 32.4964C0.965035 30.4174 0.442019 27.5161 0.494061 24.7735L0.520081 23.3918Z",
    fill: "#FF6F00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2059_1470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 2,
    width: 27,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6879 2.16699H86.0476V34.8152H60.6879V2.16699Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2059_1470)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1576 17.2285C82.9668 17.7541 83.6902 18.4072 84.2965 19.206C85.5039 20.7933 86.0555 22.6382 86.0555 24.6261C86.0555 26.2134 85.7198 27.7408 85.0199 29.1667C84.3928 30.447 83.5445 31.6101 82.3996 32.474C81.2859 33.3144 79.9771 33.8505 78.6344 34.1939C76.9873 34.6155 75.2127 34.7352 73.5187 34.7352H60.766V2.2041H73.3418C75.3324 2.2041 77.5129 2.42007 79.3526 3.22411C80.9945 3.94228 82.3059 5.07158 83.2479 6.5964C84.1404 8.03534 84.64 9.6174 84.64 11.3139C84.64 12.8856 84.2002 14.3558 83.3832 15.6932C83.0345 16.2631 82.6208 16.7731 82.1576 17.2285ZM67.854 14.5197H72.5664C73.4797 14.5197 74.9134 14.5093 75.7929 14.2465C76.3186 14.0878 76.8442 13.8328 77.1746 13.38C77.5129 12.9142 77.6118 12.3366 77.6118 11.7719C77.6118 11.1682 77.4921 10.5828 77.1668 10.0676C76.8962 9.63821 76.5319 9.37801 76.0479 9.22448C75.0097 8.89402 73.1701 8.88882 72.085 8.88882H67.854V14.5197ZM67.854 28.0505H73.5187C74.2265 28.0505 75.1736 28.0635 75.8684 27.9386C76.4435 27.8345 77.0393 27.6601 77.5389 27.3479C77.9344 27.1033 78.2259 26.739 78.4471 26.3305C78.7307 25.8049 78.8322 25.2194 78.8322 24.6261C78.8322 23.9262 78.6786 23.2731 78.2805 22.6928C77.9058 22.1516 77.401 21.8133 76.7765 21.6103C75.6811 21.2513 74.1458 21.2044 73.0035 21.2044H67.854V28.0505Z",
    fill: "#FF6F00"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0164 4.39243C35.1043 1.87103 39.9805 1.09041 44.646 2.20669C49.2829 3.31778 53.199 6.24511 55.7777 10.2471C55.8532 10.3694 55.8063 10.2887 55.8818 10.4188C58.2705 14.5327 59.1109 19.3517 58.0051 23.999C56.8992 28.6489 53.9797 32.5754 49.9881 35.1593C49.8658 35.24 49.9439 35.1905 49.8164 35.266C45.7155 37.6599 40.9095 38.503 36.2752 37.3945C31.6409 36.286 27.7274 33.3535 25.1461 29.3567C25.0655 29.2318 25.1149 29.3124 25.0421 29.1849C22.6508 25.0711 21.8103 20.2494 22.9162 15.6047C24.0299 10.9236 26.9286 6.91124 31.0164 4.39243ZM43.1733 8.41263C40.1497 7.68925 36.996 8.19145 34.3471 9.82555C31.6981 11.4571 29.8247 14.0487 29.1039 17.0801C28.3857 20.1037 28.8827 23.2574 30.4986 25.9089L30.5168 25.9376C32.1353 28.5969 34.727 30.4678 37.748 31.1911C40.7638 31.9119 43.9071 31.4071 46.5534 29.7912L46.582 29.773C49.2361 28.1519 51.0966 25.5499 51.8173 22.5237C52.5381 19.4974 52.0281 16.3463 50.42 13.6896L50.4044 13.661C48.7911 10.9965 46.1917 9.1334 43.1733 8.41263Z",
    fill: "#FFA000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2059_1470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 37,
    width: 18,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6682 37.7852H66.2876V58.7943H49.6682V37.7852Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2059_1470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.532 40.663L54.5132 38.2093C55.2704 37.7435 56.2618 37.9803 56.7249 38.7401C56.7327 38.7531 56.7405 38.7661 56.7483 38.7791L65.9909 53.8581C66.4567 54.6179 66.2199 55.6119 65.4627 56.0777C65.4497 56.0855 65.4366 56.0933 65.4236 56.1011L61.4425 58.5549L60.5994 57.181L61.4425 58.5575C60.6853 59.0232 59.6965 58.7865 59.2307 58.0266C59.2229 58.0136 59.2151 58.0006 59.2073 57.9876L49.9647 42.906L51.3334 42.063L49.9621 42.906C49.499 42.1488 49.7358 41.1522 50.4904 40.6865C50.506 40.6787 50.5164 40.6708 50.532 40.663Z",
    fill: "#5D4037"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7487 41.1471C48.9915 41.6129 48.7547 42.6069 49.2205 43.3641C49.6837 44.1239 50.6751 44.3606 51.4323 43.8949L56.9408 40.4992C57.698 40.0334 57.9322 39.0394 57.4691 38.2796C57.0033 37.5224 56.0119 37.2856 55.2573 37.7514L49.7487 41.1471Z",
    fill: "#6D4C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8454 18.6345C29.7986 19.0092 30.064 19.3501 30.4361 19.3969C30.8082 19.4437 31.1491 19.1809 31.1959 18.8062C31.503 16.3967 32.6791 14.2864 34.3887 12.7772C36.093 11.2706 38.3308 10.3677 40.7559 10.3677C40.9849 10.3677 41.2035 10.3729 41.4116 10.3885C41.6354 10.4041 41.854 10.425 42.0648 10.4536C42.4369 10.503 42.7803 10.2428 42.8298 9.86811C42.8792 9.49602 42.619 9.15255 42.2469 9.1005C41.9919 9.06668 41.7447 9.04066 41.5027 9.02504C41.2425 9.00683 40.9927 8.99902 40.7559 8.99902C37.9873 8.99902 35.4347 10.0294 33.4857 11.7494C31.5394 13.4694 30.1967 15.8789 29.8454 18.6345Z",
    fill: "#ECEFF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2059_1470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.9299,
    height: 57.9533,
    fill: "white",
    transform: "translate(0.0700684 0.976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/job_icon.3b94fa06d4e117fc0e9cbc3b8aedc1a9.svg";
export { ForwardRef as ReactComponent };